// React Query hook for Notification Policy (PRD 17 §3.7, FEATURE_049). The page is
// a read-only viewer (PRD v1.5/v1.8 + ADM.039): it loads the fixed event catalog
// and never writes. Channel ON/OFF and copy are configured in the backend/설정.

import { useQuery } from '@tanstack/react-query';

import { notificationSettingsApi } from '../api/notification-settings.adapter';

export const notificationPolicyQueryKeys = {
  all: ['notification-policies'] as const,
  list: () => [...notificationPolicyQueryKeys.all, 'list'] as const,
};

export function useNotificationPoliciesQuery() {
  return useQuery({
    queryKey: notificationPolicyQueryKeys.list(),
    queryFn: () => notificationSettingsApi.list(),
  });
}

export const sendingReferenceQueryKeys = {
  all: ['notification-sending-reference'] as const,
};

// PRD 17 §3.8 — the SMS·email reference inventory. Its own query so a failure here shows an
// independent retry and never breaks the policy table above (SHCT-427 AC-04).
export function useSendingReferenceQuery() {
  return useQuery({
    queryKey: sendingReferenceQueryKeys.all,
    queryFn: () => notificationSettingsApi.getSendingReference(),
  });
}
